import { render, staticRenderFns } from "./PricingPremiumIconCopyBox.vue?vue&type=template&id=18290a15&scoped=true&functional=true&"
var script = {}
import style0 from "./PricingPremiumIconCopyBox.vue?vue&type=style&index=0&id=18290a15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "18290a15",
  null
  
)

export default component.exports